<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/activity-dining-spec"
    entity-name="用餐规格"
    add-btn="新增"
    hide-show-detail
    :hide-action="!editable"
    :before-edit="beforeEdit"
    :modal-width="600"
    :modal-form="modalForm"
    :before-update="beforeUpdate"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:query="{form}">
      <a-form-model-item label="">
        <a-input v-model="form.name" placeholder="输入用餐规格查询" style="width: 200px"></a-input>
      </a-form-model-item>
    </template>
    <template v-slot:edit="{form}">
      <a-form-model-item label="酒店名称" prop="hotel_name">
        <a-input v-model="form.hotel_name" placeholder="请输入酒店名称"></a-input>
      </a-form-model-item>
      <a-form-model-item label="酒店地址" prop="hotel_address">
        <a-input v-model="form.hotel_address" placeholder="请输入酒店地址"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用餐地点" prop="dining_place">
        <a-input v-model="form.dining_place" placeholder="请输入用餐地点"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用餐类型" prop="dining_type">
        <a-input v-model="form.dining_type" placeholder="请输入用餐类型"></a-input>
      </a-form-model-item>
      <a-form-model-item label="用餐时间" prop="time">
        <a-range-picker
          v-model="form.time"
          :placeholder="['开始时间', '结束时间']"
          :show-time="{format: 'HH:mm'}"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"/>
      </a-form-model-item>
      <a-form-model-item label="早餐时间" prop="breakfast_time">
        <time-range v-model="form.breakfast_time"></time-range>
      </a-form-model-item>
      <a-form-model-item label="午餐时间" prop="lunch_time">
        <time-range v-model="form.lunch_time"></time-range>
      </a-form-model-item>
      <a-form-model-item label="晚餐时间" prop="supper_time">
        <time-range v-model="form.supper_time"></time-range>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import {mealColumns} from "../../../common/activity/meal";
    import mixins from "../mixins";

    export default {
        name: "MealType",
        data() {
            return {
                columns: [...mealColumns],
                rules: {
                    hotel_name: [{ required: true, message: '请输入酒店名称', trigger: 'blur' }],
                    hotel_address: [{ required: true, message: '请输入酒店地址', trigger: 'blur' }],
                    dining_place: [{ required: true, message: '请输入用餐地点', trigger: 'blur' }],
                    dining_type: [{ required: true, message: '请输入用餐类型', trigger: 'blur' }],
                    time: [{ required: true, message: '请设置用餐时间', trigger: 'change' }],
                    breakfast_time: [{ required: true, message: '请设置早餐时间', trigger: 'change' }],
                    lunch_time: [{ required: true, message: '请设置午餐时间', trigger: 'change' }],
                    supper_time: [{ required: true, message: '请设置晚餐时间', trigger: 'change' }],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'meal-type',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeEdit(form, fn) {
                form.time = [form.dinner_start_time, form.dinner_end_time];
                form.breakfast_time = [form.breakfast_start_time, form.breakfast_end_time];
                form.lunch_time = [form.lunch_start_time, form.lunch_end_time];
                form.supper_time = [form.supper_start_time, form.supper_end_time];
                fn();
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                if(form.time) {
                    form.dinner_start_time = form.time[0];
                    form.dinner_end_time = form.time[1];
                }
                if (form.breakfast_time) {
                    form.breakfast_start_time = form.breakfast_time[0];
                    form.breakfast_end_time = form.breakfast_time[1];
                }
                if (form.lunch_time) {
                    form.lunch_start_time = form.lunch_time[0];
                    form.lunch_end_time = form.lunch_time[1];
                }
                if (form.supper_time) {
                    form.supper_start_time = form.supper_time[0];
                    form.supper_end_time = form.supper_time[1];
                }
                fn();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
